module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_kimono@3x-988ac7a6e8559cf0d3142167b15fac57.webp";